import React from "react";
import QuoteSummaryBar from "./QuoteSummaryBar";
import SaveAsQuoteDialog from "../common-quote/SaveAsQuoteDialog";
import { MobileTopButton } from "../MobileTopButton";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { FixAndFlipForm } from "../../lib/models/short-term/short-term-form.model";
import { CalculationType } from "../../state/quote-reducer";
import {
  RentalForm,
  RentalPremierForm,
} from "../../lib/models/rental/rental-form.model";

export interface QuoteBoxBottomProps {
  formActionHandler: (action: QuoteFormActions, values: FixAndFlipForm) => void;
  calculation: CalculationType;
  onSaveClick: (
    values: FixAndFlipForm | RentalForm | RentalPremierForm
  ) => void;
  isOpen: boolean;
  onClose: () => void;
}

const QuoteBoxBottom = (props: QuoteBoxBottomProps) => {
  return (
    <>
      <QuoteSummaryBar
        formActionHandler={props.formActionHandler}
        calculation={props.calculation}
      />

      <SaveAsQuoteDialog
        onSaveClick={props.onSaveClick}
        isOpen={props.isOpen}
        onClose={props.onClose}
      />

      <MobileTopButton aria-label="Scroll to top" />
    </>
  );
};

export default QuoteBoxBottom;
